'use strict';

angular.module('mobile-apps').controller('AutotranslateFromTmController', [
	'$scope',
	'$modalInstance',
	function (
		$scope,
		$modalInstance
	) {

		$scope.options = [
			{
				id: 'ignoreCase',
				name: 'Ignore case',
				checked: false
			},
			{
				id: 'ignoreWhitespaces',
				name: 'Ignore leading/trailing whitespaces',
				checked: false
			}
		];


		/**
		 * Starts autotranslate
		 */
		$scope.startAutotranslate = function () {

			var returnOptions = {};
			$scope.options.forEach(function(option) {
				returnOptions[option.id] = option.checked;
			});

			$modalInstance.close(returnOptions);
		};

	}
]);

